import { render, staticRenderFns } from "./RelativeRelationAdd.vue?vue&type=template&id=34452ff2&scoped=true&"
import script from "./RelativeRelationAdd.vue?vue&type=script&lang=js&"
export * from "./RelativeRelationAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34452ff2",
  null
  
)

export default component.exports